import React, { Component } from 'react'
import moment from "moment";
import {Link} from 'react-router-dom';
import FilterActiveIcon from "./../icons/filteractiveicon";
import FilterIcon from "./../icons/filtericon";

import MainLayout from './../mainLayout/index';

// import Loader from "../../loader";
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "./../redux/bindActionCretor";

import ReactPaginate from "react-paginate";
import PlusIcon from './../icons/plusicon';

import ShortProgramList from './../component/fpg/list/shortProgramList';
import ShortProgramEpisodicList from './../component/fpg/list/shortProgramEpisodicList';
import service from '../services'
import commonImage from '../commonImage';
import ErrorPopUp from '../component/errorPopUp';
import ScreeningsCsvUploadModal from './ScreeningsCsvUploadModal';
import UploadImg from '../assets/images/cloud-data-upload-icon.svg'
import UploadImgicon from '../assets/images/upload_csv_icon.png'


const mapStateToProps = (state) => ({
    shortProgramId:state.shortProgramId,
    currentShortTab: state.currentShortTab,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActCreators, dispatch);
};

let sub;
class ShortProgram extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
            showModalPopup: false,
           uploadCSVModal: false,
           totalAddedRecord: 0,
           fileUploading: false,
           totalSkippedRecord: 0,
           skippedUser: [],
           data:[
            {
                label:'Short Program',
                content:''
            },
            {
                label:'Episodic Pilot Showcase',
                content:''
            }],
            activetab: this.props.currentShortTab || 0,
        };
        this.apiserve = new service();
      }

    clearAllForm = () => {
        this.props.ShortProgramEditData('')
        this.props.EpisodicShortProgramEditData('')
        if (this.state.activetab === 0) {
            this.props.history.push('/program')
        } else {
            this.props.history.push('/episodic-program')
        }
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    };

    componentDidMount() {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "admin|screening|importShortScreeningsCSV":
                    if (!response.error) {
                        this.setState({
                            fileUploading: false,
                            totalAddedRecord: (response.data.totalProcessedRecords + response.data.totalUpdateRecords),
                            totalSkippedRecord: response.data.totalFailedRecords,
                            skippedUser: response.data.skipRecordArray
                        }, () => {
                            this.setState({
                                uploadCSVModal: true
                            })
                        })
                        this.apiserve.sendevent("fpg|shortProgramme|getList", {programType: this.state.activetab === 0 ? '1' : '2'});
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "admin|screening|downloadShortCSV":
                    if (!response.error) {
                        window.open(response.data)
                        this.setState({
                            showModalPopup: false
                        })
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                default:
                    break;
            }
        })
    }

    isShowPopup = (e,status) => {
        e.stopPropagation();
        this.setState({ showModalPopup: status });
    };

    onCancleFilter = () => {
        this.setState({
          showModalPopup: false
        })
    }
    
    downloadcsv = () => {
        const req = { programType: this.state.activetab === 0 ? '1' : '2' }
        this.apiserve.sendevent("admin|screening|downloadShortCSV", req);
    }


    uploadCSV = (e) => {
        let file = e.target.files[0];
        if ((file.type === 'text/csv' || file.type === 'application/vnd.ms-excel') || file.name.includes('.csv') || (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
            this.setState({
                fileUploading: true
            })
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (event) => {
                setTimeout(() => {
                    this.imageUploadScreen(file,false,event.target.result);
                }, 0);
            };
            e.target.value = ''
        } else {
            this.setState({ errorMsg: 'please upload .csv file only', errorPopup: true, fileUploading: false })
        }
    }

    imageUploadScreen = (file,IsFPGUpload=true,img) => {
        var fileSet = commonImage(file,IsFPGUpload, this.apiserve.formbucketCSV,img)
        fileSet.then((value) => {
            var data1 = {
                url: encodeURI(process.env.REACT_APP_IMAGE_URL + value),
                programType:this.state.activetab === 0 ? '1' : '2'
            }
            this.apiserve.sendevent("admin|screening|importShortScreeningsCSV", data1);
        });
        
    };
    
    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }

    CloseModal = () => {
        this.setState({
            uploadCSVModal:false,
            showModalPopup: false
        })
    }

    TabClick = index => {
        this.setState({
          activetab: index
        }, () => {
            this.props.CurrentShortTab(index)
        });
      }
    
    render() {
        return (
            <React.Fragment>
              {/* <MainLayout history={this.props.history}> */}
                  <div className="right_side_wrapper">
                        <ul className="fpg_admin_tab disp_flex">
                            {
                                this.state.data && this.state.data.map((list,index) => {
                                        return(
                                            <li className={this.state.activetab === index ? 'active' : '' }>
                                               <p>
                                                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => this.TabClick(index)}>
                                                    <div style={{ paddingRight: '10px',position:'relative' }}>{list.label}</div>
                                                    {this.state.activetab === index && <div className="icon_block" onClick={(e) => this.isShowPopup(e,true)}>
                                                        <img src={UploadImgicon} style={{position:'absolute',right:'77px',bottom:'15px',width:'22px'}} />
                                                    </div>}
                                                  </div>
                                                    {this.state.activetab === index && <span id= {index} onClick={(e)=>this.clearAllForm(e)}><PlusIcon /></span>}
                                                </p>
                                            </li>
                                        )
                                })
                            }
                        </ul>
                        {/* </div> */}
                          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                            <p></p>
                            <p className="update_date">
                                {/* Last Update:  */}
                            {/* {hour}:{minutes} {state} - {moment(updateAt).format('MM/DD/YYYY')} Last Updated By: {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname} */}
                            </p>
                        </div>
                        {this.state.activetab === 0 && <ShortProgramList history={this.props.history} TabClick={this.TabClick} />}
                        {this.state.activetab === 1 && <ShortProgramEpisodicList history={this.props.history} TabClick={this.TabClick}/>}
                        {this.state.showModalPopup && (
                            <div className='user_popup active'>
                                <span className="popup_overlay" onClick={this.onCancleFilter}></span>
                                <div className="sundance_popup_detail box_shadow approve_success_popup bg_white overflow_initial fpg_csv_btn" >
                                <div className="approve_popup_header text_center relative pb_0  fpg_approve_popup">
                                    <span className="close_popup fpg_close_popup" onClick={this.onCancleFilter}>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.192 0.343994L5.949 4.58599L1.707 0.343994L0.292999 1.75799L4.535 5.99999L0.292999 10.242L1.707 11.656L5.949 7.41399L10.192 11.656L11.606 10.242L7.364 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                    </svg>
                                    </span>
                                    
                                    <div className="head_btn pointer upload_pdf_btn" onClick={() => this.downloadcsv()}  style={{marginLeft:'17px',marginTop:'10px'}}>
                                    <span className="upload_pdf"></span>
                                    Download Sample</div>

                                    <span className="head_btn pointer upload_pdf_btn"  style={{marginLeft:'17px',marginTop:'10px'}}><input type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={this.uploadCSV} className="upload_pdf" />Upload File <img src={UploadImg} style={{width:'19px',marginLeft:'5px',marginRight:'5px'}} />{this.state.fileUploading &&
                                            <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                        }</span>
                                </div>
                                </div>
                            </div>
                        )}
                        {this.state.errorPopup ?
                            <ErrorPopUp
                                errorMsg={this.state.errorMsg}
                                errorMsgPopup={this.errorMsgPopup}
                            />
                            : ''
                        }

                    {/* For CSV upload successfully */}
                    <div className={`user_popup ${this.state.successmodal ? "active" : null}`}>
                        <span className="popup_overlay" onClick={this.CloseModal}></span>
                        <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                            <div className="approve_popup_header text_center relative">
                                <p>You have successfully uploaded {this.state.totalAddedRecord} users</p>
                            </div>
                            <div className="content">
                                <div className="field_row text_center">
                                    <button className="small_btn active" onClick={this.CloseModal}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.uploadCSVModal ? <ScreeningsCsvUploadModal CloseModal={this.CloseModal} totalAddedRecord={this.state.totalAddedRecord} totalSkippedRecord={this.state.totalSkippedRecord} skippedUser={this.state.skippedUser} /> : ''}
                    </div>    
              {/* </MainLayout> */}
            </React.Fragment>   
        )
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(ShortProgram);